import { TableColumnModel } from '../../../Forms/models/table-column.model';
import { TableColumnInputEnum } from '../../../Forms/enums/table-column-input-type.enum';

export const styleNameColumnConfig: TableColumnModel = {
    type: TableColumnInputEnum.text,
    heading: 'Styles.manageDialog.column.styleName',
    field: 'name',
    tooltipField: 'name',
    sortable: true,
    sortType: 'text',
    selectable: true,
    selectField: 'selected',
    maxWidth: 400,
    cellStyleClass: 'agpr-table-cell--primary'
};
